import { call } from "./call";

export const send = (info, successCallback, errorCallback) =>
  call(
    "/contacts",
    {
      method: "POST",
      body: JSON.stringify({
        contact: {
          first_name: info.firstName,
          last_name: info.lastName,
          phone: info.phone,
          email: info.email,
          message: info.message,
        },
      }),
    },
    successCallback,
    errorCallback
  );



// WEBPACK FOOTER //
// ./src/api/contacts.js